import { Paper, styled } from '@mui/material';
import MediaTypography from 'components/MediaTypography';

export const BookItemLink = styled('a')(() => ({
	textDecoration: 'none',
}));

export const BookItemWrap = styled(Paper)(({ theme }) => ({
	display: 'flex',
	flex: 1,
	cursor: 'pointer',

	'&:hover': {
		boxShadow: '0px 0px 30px 0px #827D8380',
		'& h2': {
			color: theme.palette.primary.main,
		},
	},

	padding: '8px',
	borderRadius: '16px',
	gap: '8px',
	height: '200px',
}));

export const BookItemImg = styled('img')(() => ({
	height: '100%',
	objectFit: 'cover',
	objectPosition: 'center',
	maxWidth: '100%',

	borderRadius: '10px',
	aspectRatio: '21 / 32',
}));

export const BookItemInfoWrap = styled('div')(() => ({
	display: 'flex',
	flexDirection: 'column',
	flex: 1,

	gap: '4px',
	padding: '4px 0px',
}));

export const BookItemInfoTitle = styled(MediaTypography)(() => ({
	transition: 'all cubic-bezier(0.4, 0, 0.2, 1) 300ms',
	textWrap: 'balance',

	wordBreak: 'break-all',
}));

export const BookItemInfoSubTitle = styled(MediaTypography)(() => ({
	marginTop: '4px',
	wordBreak: 'break-all',
}));

export const BookArrayItemImagesWrap = styled('div')(() => ({
	display: 'grid',
	gridTemplateColumns: 'repeat(2,1fr)',
	gridTemplateRows: 'repeat(2,1fr)',
	height: '100%',
	aspectRatio: '10/16',
	background: '#FFFFFFB2',
	borderRadius: '10px',
	padding: '4px',
	gap: '4px',
}));
